export const SUP_SOFTWARE_BIACORE_DOWNLOADS_LOADER = {
  desktop: `
<div class="cui">
  <div class="cui-skeleton-heading__content -spacing--bottom-40" style="width: 100%;">
    <div class="cui-skeleton__item cui-skeleton-heading__title" style="height: 300px; width: 100%;"></div>
  </div>
  
  <div class="cui-grid">
    <div class="cui-container">
      <div class="cui-row">
        <div class="cui-col-12 cui-col-md-4 cui-col-lg-4">
          <div class="cui-skeleton-rectangle -spacing--bottom-24 -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 270px;"></div>
          </div>
        </div>
        <div class="cui-col-12 cui-col-md-4 cui-col-lg-4">
          <div class="cui-skeleton-rectangle -spacing--bottom-24 -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 270px;"></div>
          </div>
        </div>
        <div class="cui-col-12 cui-col-md-4 cui-col-lg-4">
          <div class="cui-skeleton-rectangle -spacing--bottom-24 -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 270px;"></div>
          </div>
        </div>
        <div class="cui-col-12 cui-col-md-4 cui-col-lg-4">
          <div class="cui-skeleton-rectangle -spacing--bottom-24 -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 270px;"></div>
          </div>
        </div>
        <div class="cui-col-12 cui-col-md-4 cui-col-lg-4">
          <div class="cui-skeleton-rectangle -spacing--bottom-24 -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 270px;"></div>
          </div>
        </div>
        <div class="cui-col-12 cui-col-md-4 cui-col-lg-4">
          <div class="cui-skeleton-rectangle -spacing--bottom-24 -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 270px;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`
};
